



















































































import { defineComponent } from '@vue/composition-api';
import { ProductCategoryOption } from '@/models/entities/ProductCategoryOption';

interface Props {
  entityOptions: ProductCategoryOption[];
}

const Component = defineComponent({
  name: 'ProductCategoryOptionsSimpleTable',

  props: {
    entityOptions: Array,
  },

  setup() {
    const isQuantityMissed = (value: number | string | null) =>
      value === 0 || value === '0' || value === '' || value === null || value === undefined;

    function isAllOptionValuesMissed(option: ProductCategoryOption): boolean {
      return (
        isQuantityMissed(option.pricePerPair) &&
        isQuantityMissed(option.minQuantity) &&
        isQuantityMissed(option.minSizeQuantity)
      );
    }

    function changeOption(option: ProductCategoryOption) {
      option.hasOverriddenValue = !isAllOptionValuesMissed(option);
    }

    return { changeOption };
  },
});
export default Component;
